import { string } from 'prop-types';
import Input from '../../../shared/Input';
import { Stack, FormStack } from '../../../shared/layouts';
import Card from '../../../shared/Card';
import Header from '../../../shared/Header';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../../hooks/useIconLibrary";

const ContactCard = ({
  firstname,
  lastname,
  phone_number,
  email,
}) => {
  const { t } = useTranslation();
  const { MessageIcon } = useIconLibrary();

  let title = t('Contactpersoon')
  if (firstname || lastname) {
    title = `${firstname} ${lastname}`
  }

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={title}
          icon={<MessageIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <FormStack space="m" readOnly={true}>
          <Input
            type="tel"
            label={t("Telefoonnummer")}
            value={phone_number || ''}
            readOnly={true}
          />
          <Input
            label={t("E-mailadres")}
            value={email}
            readOnly={true}
          />
        </FormStack>
      </Stack>
    </Card>
  );
}

ContactCard.propTypes = {
  firstname: string,
  lastname: string,
  phone_number: string,
  email: string,
};

ContactCard.defaultProps = {
  firstname: '',
  lastname: '',
  phone_number: '',
  email: '',
};
export default ContactCard;
